import { getChannel, getPlaylists, searchYoutube, createPlaylist, insertIntoPlaylist } from '../lib/youtube-api';
import { handleAuthClick } from '../lib/youtube-auth';
// import throat from 'throat';

// At 3, 3.5 seconds, 16 songs, order not guaranteed?
// At 2, 7 seconds, 16 songs, order not guaranteed?
// At 1, 10 seconds, 16 songs, in order :D, .6 seconds per song
let throat = require('throat')(3);
throat = require('throat')(1);

let cancelConversion = false;
let retrySearches = [];
let retryAddToPlaylist = [];
let playlistId = '';

// Must return a promise to throat
const promiseSearch = (searchString) => {
  return new Promise((resolve) => {
    searchYoutube(searchString, resolve);
  });
};

const promiseAddToPlaylist = (videoId, playlistId) => {
  return new Promise((resolve) => {
    insertIntoPlaylist(videoId, playlistId, resolve);
  });
};

const promiseCreatePlaylist = (playlistName) => {
  return new Promise((resolve) => {
    const isPrivate = false;
    createPlaylist(playlistName, isPrivate, resolve);
  });
};

const checkCancelConversion = () => {
  if (cancelConversion) {
    cancelConversion = false;
    return true;
  }

  return false;
}

const handleExpiredTokenDuringConversion = () => {
  alert('Please click ok, select your YouTube account, and sign in so Playlist Buddy can continue converting. Make sure popups are not blocked!');
  handleAuthClick(); // Popups are blocked so we should do a dialog and have the user click
  // How do we proceed where they left off? Similar flow for rate limit issues
};

const searchBatch = (songs) => {
  const searchThroatPromises = songs.map((song) => {
    const searchString = `${song.songName} ${song.artistName}`; // add filter string here // filter.query

    return throat(() => promiseSearch(searchString));
  });

  return Promise.all(searchThroatPromises).then((results) => {
    const videoIdsFound = [];
    const searchesNotFound = [];
    let pauseForSignIn = false;

    results.map((result) => {
      if (result.success) {
        const {song, searchString} = result.success;
        videoIdsFound.push(song.videoId);
      }

      if (result.error) {
        const {message, searchString} = result.error;

        if (message === 'NOT_SIGNED_IN') {
          pauseForSignIn = true;
        }

        searchesNotFound.push(searchString);
      }
    });

    if (searchesNotFound.length > 0) {
      retrySearches.concat(searchesNotFound);
    }

    return { videoIdsFound, pauseForSignIn };
  });
};

const addToPlaylistBatch = (videoIdsFound) => {
  const addToPlaylistThroatPromises = videoIdsFound.map((videoId) => {
    return throat(() => promiseAddToPlaylist(videoId, playlistId)); // Set globally in addAllToPlaylist, which comes from Promise success in view
  });

  return Promise.all(addToPlaylistThroatPromises).then((results) => {
    const videoIdsAdded = [];
    const videoIdsNotAdded = [];
    let pauseForSignIn = false;

    results.map((result) => {
      if (result.success) {
        const { song, videoId, playlistId } = result.success;
        videoIdsAdded.push(videoId);
      }

      if (result.error) {
        const { message, videoId, playlistId } = result.error;

        if (message === 'NOT_SIGNED_IN') {
          pauseForSignIn = true;
        }

        videoIdsNotAdded.push({ videoId, playlistId });
      }
    });


    if (videoIdsNotAdded.length > 0) {
      retryAddToPlaylist.concat(videoIdsNotAdded);
    }

    return { videoIdsAdded, pauseForSignIn };
  });
};

const convertBatch = (songs) => {
  return new Promise((resolve, reject) => {
    searchBatch(songs).then(({ videoIdsFound, pauseForSignIn }) => {
      if (checkCancelConversion()) {
        // Good time to check for a 403, pause conversion for cool off or YouTube sign in
        return reject('CONVERSION_CANCELLED');
      }

      if (pauseForSignIn) {
        handleExpiredTokenDuringConversion();
        return reject('YOUTUBE_SIGNIN_DURING_CONVERSION');
      }

      // do we want a timeout here?
      addToPlaylistBatch(videoIdsFound).then(({ videoIdsAdded, pauseForSignIn }) => {
        if (checkCancelConversion()) {
          // Good time to check for a 403, pause conversion for cool off or YouTube sign in
          return reject('CONVERSION_CANCELLED');
        }

        if (pauseForSignIn) {
          handleExpiredTokenDuringConversion();
          return reject('YOUTUBE_SIGNIN_DURING_CONVERSION');
        }

        return resolve();
      });
    });
  });
};

const handleBatch = (batches, index, resolve, progressCallback) => {
  if (index < batches.length) {
    convertBatch(batches[index]).then(() => {
      progressCallback(index + 1);
      handleBatch(batches, index + 1, resolve, progressCallback);
    }, () => { resolve('EARLY_EXIT' )});
  } else {
    resolve('DONE');
  }
};

const addAllToPlaylist = (songs = [], pId, progressCallback, filter = {}) => {
  playlistId = pId;
  if (filter.makePrivate) {
    // make playlist private
  }

  if (filter.removeDuplicates) {
    // add to query
  }

  if (filter.shuffleOrder) {
    // add to query
  }

  const batches = [];
  const BATCH_SIZE = 3;
  cancelConversion = false;

  for (let a = 0; a < songs.length; a += BATCH_SIZE) {
    const batch = [];

    for (let b = 0; b < BATCH_SIZE; b++) {
      if (a + b < songs.length) {
        batch.push(songs[a + b]);
      }
    }
    batches.push(batch);
  }

  const batchesPromise = new Promise((resolve) => {
    if (batches.length > 0) {
      handleBatch(batches, 0, resolve, (index) => progressCallback(index * BATCH_SIZE));
    } else {
      resolve();
    }
  });

  batchesPromise.then((value) => {
    progressCallback(songs.length);
  });
};

const cancelAddAllToPlaylist = () => {
  cancelConversion = true;
};

export {
  addAllToPlaylist,
  cancelAddAllToPlaylist,
  promiseCreatePlaylist
}



// WEBPACK FOOTER //
// ./src/lib/youtube-converter.js